import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'cr-heatmap-overlay',
  styleUrl: 'cr-heatmap-overlay.css',
  shadow: true,
})
export class CrHeatmapOverlay {

  @Prop() element

  @Prop() taskdata

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }

}
